export default __webpack_public_path__ + "static/media/massage-thumbnail.d89b970f.jpg";